import AppDispatcher from '../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import { CHANGE_EVENT } from '../constants/AppConstants';
import { getAllVerifications } from '../utils/UserVerificationApiUtils';
import {
  GET_ALL_VERIFICATION,
  GET_ALL_VERIFICATION_SUCCESS,
  GET_ALL_VERIFICATION_FAILURE,
} from '../actions/UserVerificationActionCreator';

let verificationList = [];
let error = null;
// todo wtf is going on here!
let hasError = false; // eslint-disable-line

class UserVerificationStore extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
  }

  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  getAllVerification() {
    return verificationList;
  }

  getError() {
    return error;
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }

  reset() {
    verificationList = [];
    hasError = false;
    error = null;
  }

  dispatcherCallback(data) {
    switch (data.action.actionType) {
      case GET_ALL_VERIFICATION: {
        verificationList = [];
        hasError = false;
        getAllVerifications();
        break;
      }
      case GET_ALL_VERIFICATION_SUCCESS: {
        verificationList = data.action.verificationList;
        hasError = false;
        this.emitChange();
        break;
      }
      case GET_ALL_VERIFICATION_FAILURE:
        verificationList = [];
        hasError = true;
        error = data.action.error;
        this.emitChange();
        break;
      default: {
        break;
      }
    }
  }
}

export default new UserVerificationStore();
